import React from 'react'

const Response = ({ children, ...props }) => (
  <strong { ...props } className={ `${ props.className || '' } response` }>{ children }</strong>
)

export default Response